export class GlobalStateModel {
  constructor() {}
  initSystem?: boolean; //系统参数是否初始化成功
  theme?: string; //当前主题
  userInfo?: any; //当前登录用户信息
  showTemHome?: boolean; //是否使用首页2
  homeFirstTem?: any; //首页模块入口
  homeSecondTem?: any; //首页2展示的功能模块
  notificationTimmer?: any; //本地推送定时器实例
  codelist?: any; //字典表
  claimTypes?: any; //字典表 业务类型
  currentCity?: any; // 当前定位的城市信息 ？？？
}

//上面定义的属性要在下面初始化
export const GSM = {
  initSystem: "false",
  theme: "theme-default",
  userInfo: {},
  showTemHome: false,
  homeFirstTem: {},
  homeSecondTem: {},
  notificationTimmer: undefined,
  codelist: {},
  claimTypes: {},
  currentCity: {},
};



// WEBPACK FOOTER //
// ./src/services/common/app/global/app.global.model.ts